import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import styled from 'styled-components'
import loader from '../assets/loader.png'
import { useNavigate } from 'react-router-dom';

const Loading = () => {
    const navigate = useNavigate();
    useEffect(() => {
        const timer = setTimeout(() => {
            let random = Math.random();
            if (random < 0.35) {
                navigate('/error', { replace: true });
            } else {
                navigate('/result', { replace: true });
            }
        }, 5000);
        return () => clearTimeout(timer);
    }, [navigate]);
    return (
        <Container>
            <SubTitle>Continental Car & Van tires</SubTitle>
            <Title>We are analyzing the photo. Please be patient for a moment.</Title>
            <Loader src={ loader } />
        </Container>
    );
}
const Container = styled.div`
    width: 90%;
    padding-top: 50px;
    margin: 0 auto;
    text-align: center;
`
const SubTitle = styled.p`
    font-family: ContinentalMedium;
    font-size: 16px;
    margin-bottom: 5px;
`
const Title = styled.p`
    font-family: ContinentalMedium;
    width: 268px;
    margin: 0 auto;
    font-size: 30px;
    line-height: 38px;
    margin-bottom: 95px;
`
const Loader = styled.img`
    width: 90px;
    height: 90px;
    animation-name: rotation;
    animation-duration: 4s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    @keyframes rotation {
        from {
            transform: rotate(0deg)
        }
        to {
            transform: rotate(360deg)
        }
    }
`
export default Loading;